/*
*
* =================================================================================================================
* ČISELNIKY

    USAGE:
    ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    <Window organization={organization} user={user} lang={lang} language={language} locale={locale} theme={theme} offset={offset} radius={radius} isSmall={isSmall} title={lang.cond_designer} token={token} func={() => closeWindow()} />
    ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

    

* =================================================================================================================
*
*/
import React, { useEffect, useState } from 'react';

import './App.css';
import './styles.css';

import { EmptyList, FormError, FormSpace, FormText, FormYesNo, Icon, Loading, ShowError, ShowOK, TextInput, SwitchEnable, MenuButton, SelectInput, DialogExport, SearchButton, FormSelect, DialogTabs, FormColors } from './items';
import { styles } from './styles';
import { Backdrop, Button, Checkbox, IconButton, Pagination, Paper } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp, faLayerGroup, faPlus, faPlusCircle, faQuestion, faXmark } from '@fortawesome/free-solid-svg-icons';
import { CheckPermission, Debug, GetLeftPosition, IsEmpty } from './functions';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

export const CodeBooks = (props) => {

    let module_id = global.model.order_types;

    var lang = props.lang;
    let radius = props.radius;
    let color = global.themes[props.theme];
    let permissions = global.permissions;
    let permission_column = 'code_book';

    let defaultFilter = {
        ordering: global.order.down,
        order_column: 'name'
    }

    // MENU -> ZORADOVANIE ASC / DESC
    const itemsOrdering = [
        { id: 1, enabled: true, label: lang.ordering, icon: faArrowUp },
        { id: 2, enabled: true, label: lang.ordering, icon: faArrowDown }
    ];

    // MENU -> EXPORTOVANIE UDAJOV
    const itemsExportMenu = [
        { id: 1, enabled: true, label: lang.export_selected },
        { id: 2, enabled: true, label: lang.export_all }
    ];

    /* Exportované údaje
            column   -> názov stĺpca v DB
            label    -> názov stĺpca - LABEL
            typ      -> typ premennej
    */
    const exportColumns = [
        { id: 1, column: 'name', label: lang.vendor_name, typ: 'text' },
        { id: 2, column: 'street', label: lang.street, typ: 'text' },
        { id: 3, column: 'town', label: lang.town, typ: 'text' },
        { id: 4, column: 'psc', label: lang.psc, typ: 'text' },
        { id: 5, column: 'state', label: lang.state, typ: 'text' },
        { id: 6, column: 'phone', label: lang.phone, typ: 'text' },
        { id: 7, column: 'mobil', label: lang.mobil, typ: 'text' },
        { id: 8, column: 'email', label: lang.email, typ: 'text' },
        { id: 9, column: 'note', label: lang.note, typ: 'text' },
        { id: 100, column: 'enabled', label: lang.enabled, typ: 'boolean' },
    ];

    const codebooks = [
        { id: 0, enabled: true, label: lang.stock_adjustment },
        { id: 1, enabled: true, label: lang.stock_transports_ },
        { id: 2, enabled: true, label: lang.reklamacia_reasons },
        { id: 3, enabled: true, label: lang.reklamacia_denies },
        { id: 4, enabled: true, label: lang.plans },
        { id: 5, enabled: props.system.product_book_1 == false ? false : true, label: lang.products + ': ' + props.system.product_book_label_1 },
        { id: 6, enabled: props.system.product_book_2 == false ? false : true, label: lang.products + ': ' + props.system.product_book_label_2 },
        { id: 7, enabled: props.system.product_book_3 == false ? false : true, label: lang.products + ': ' + props.system.product_book_label_3 },
        { id: 8, enabled: props.system.eshop_enabled == true || props.system.marketing_enabled == true ? true : false, label: lang.blogs },
        { id: 9, enabled: props.system.marketing_enabled == true ? true : false, label: lang.newsletter_emails_categories },
        { id: 10, enabled: props.system.eshop_enabled == true ? true : false, label: lang.product_params },
        //{ id: 100, enabled: props.system.eshop_enabled == true ? true : false, label: lang.codebook_user_defined },
    ];

    const tabs = [
        { id: 0, enabled: true, label: lang.codebooks_system },
        { id: 1, enabled: true, label: lang.codebook_user_defined_values },
    ];

    // SYSTEM
    const [isBusy, setBusy] = useState(false);
    const [redraw, setRedraw] = useState(false);
    const [error, setError] = useState('');
    const [index, setIndex] = useState(0);

    const [showOK, setShowOK] = useState(false);
    const [showError, setShowError] = useState(false);

    // TABS
    const [bookIndex, setBookIndex] = useState(0);
    const [tabIndex, setTabIndex] = useState(0);

    // DATA LIST
    const [items, setItems] = useState(false);
    const [itemsFiltered, setItemsFiltered] = useState(false);
    const [itemSelected, setItemSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [pages, setPages] = useState(0);
    const [maxItems, setMaxItems] = useState(20);
    const [filter, setFilter] = useState(defaultFilter);
    const [overID, setOverID] = useState(-1);
    const [search, setSearch] = useState('');
    const [ordering, setOrdering] = useState(defaultFilter.ordering);
    const [orderColumn, setOrderColumn] = useState(defaultFilter.order_column);
    const [selectedAll, setSelectedAll] = useState(false);

    const [codeBookID, setCodeBookID] = useState(global.codebook.reasons);
    const [paramID, setParamID] = useState(0);

    // SEARCH COLUMNS
    const [searchColumns, setSearchColumns] = useState([
        { id: 1, enabled: true, checked: true, column: 'name', label: lang.label, default: true },
    ]);

    // VALUES
    const [menuIndex, setMenuIndex] = useState(0);

    // DIALOGS
    const [showDialog, setShowDialog] = useState(false);
    const [showExport, setShowExport] = useState(false);

    // SCREEN SETTINGS
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);


    // CONSTANTS
    const tabHeight = props.system.eshop_enabled == true ? 60 : 0;
    const menuHeight = 50;
    const rowHeight = 46;
    const tableLabelHeight = 40;
    const paginationHeight = 50;
    const rowWidth = props.width < 1000 ? props.width - 40 : 960

    let { func } = props;
    var running = false;

    useEffect(() => {
        if (running == false) {

            // UDAJE Z DB
            db_get(global.codebook.reasons, defaultFilter);

            running = true;
        }

    }, []);


    const db_get = async (book_id, filter) => {

        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'codebooks', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: props.token,
                    user_id: props.user.id,
                    organization_id: props.organization.id,
                    // -------------------------------------
                    book_id: book_id,
                    filter: filter
                })
            })

            const json = await response.json();
            Debug(json);
            if (json.ok > 0) {
                var tmp = json.items;
                setItems(tmp);
                setItemsFiltered(tmp);

                setFilter(filter);
                setOrdering(filter.ordering);
                setOrderColumn(filter.order_column);
                GoToStart();
            }
            setBusy(false);

        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }

    // -----------------------------------
    // UPDATE DB - ENABLE / DISABLE
    // -----------------------------------
    const db_update = async (data) => {
        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'codebook_update', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: props.token,
                    user_id: props.user.id,
                    organization_id: props.organization.id,
                    // -------------------------------------
                    data: data
                })
            })

            const json = await response.json();

            if (json.ok > 0) {
                var tmp = items.find(x => x.id === data.id);
                if (tmp != undefined) {
                    tmp.enabled = data.enabled;
                }

                setShowOK(true);
            } else {
                setShowError(true);
            }
            setBusy(false);

        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }

    // -----------------------------------
    // EXPORT DATA
    // -----------------------------------
    const db_export = async (itemRows, note) => {
        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'export_data', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: props.token,
                    user_id: props.user.id,
                    organization_id: props.organization.id,
                    // -------------------------------------
                    typ: global.export_type.xls,
                    model_id: module_id,
                    label: lang.order_types,
                    filename: lang.order_types, // názov súboru po stiahnutí
                    item_rows: itemRows,
                    columns: exportColumns,
                    note: note
                })
            })

            const json = await response.json();
            Debug(json);
            if (json.ok > 0) {
                setShowOK(true);
            } else {
                setShowError(true);
            }
            setBusy(false);

        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }

    const db_reorder = async (items) => {
        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'reorder_items', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: props.token,
                    user_id: props.user.id,
                    organization_id: props.organization.id,
                    // -------------------------------------
                    model_id: global.model.codebook,
                    items: items
                })
            })

            const json = await response.json();
            Debug(json);
            if (json.ok > 0) {
                setShowOK(true);
            } else {
                setShowError(true);
            }
            setBusy(false);

        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }

    const Press = (typ, value) => {
        func(typ, value);
    }

    const Close = () => {
        Press(0, 0);
    }

    const Search = (txt) => {
        setSearch(txt);

        var filter = {};

        if (txt.length > 1) {
            filter.name = txt;
            db_get(codeBookID, filter);
        }
        if (txt == '') {
            db_get(codeBookID, false);
        }
    }

    const ChangePage = (value) => {
        setSelectedAll(false);
        db_get(value - 1, filter, maxItems);
    }

    const GoToStart = () => {
        setTimeout(() => {
            const element = document.getElementById('id_start');

            if (element != null) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }, global.goto_start_delay);
    }

    const AddNew = () => {
        setItemSelected(false);
        setShowDialog(true);
    }

    const SelectItem = (item) => {
        if (CheckPermission(props.user.super_admin, props.permissions[permission_column]).edit == true) {
            setItemSelected(item);
            setShowDialog(true);
        }
    }

    const DialogResult = (redraw) => {
        setShowDialog(false);

        if (redraw == true) {
            db_get(codeBookID, filter);
        }
    }

    const ChangeEnabled = (item, value) => {
        // ENABLED POLOZKY ZMENENY
        /*
        let log = {
            organization_id: props.organization.id,
            user_id: props.user.id,
            module_id: module_id,
            item_id: item.id,
            action: value == true ? global.logs.enabled : global.logs.disabled
        };
        */

        let data = {
            id: item.id,
            enabled: value,
            //logs: log
        }
        db_update(data);
    }

    const MenuResult = (id, index) => {
        // EXPORT MENU
        var enable = true;
        if (index == 1) {
            let tmp = items.find(x => x.selected === true);
            if (tmp == undefined) {
                enable = false;
            }
        }

        if (enable == true) {
            setMenuIndex(index);
            setShowExport(true);
        }
    }

    const MenuSortResult = (id, index) => {
        let order = index == 1 ? global.order.up : global.order.down;
        var column = 'name';

        switch (id) {

            case 1: // NAZOV
                column = 'name';
                break;

            case 2: // ENABLED
                column = 'enabled';
                break;
        }

        var filter = {
            ordering: order,
            order_column: column
        };
        if (search != '') {
            filter.search = search;
        }
        db_get(0, filter, maxItems);
    }

    const ChangeSelected = (item) => {
        item.selected = !item.selected;
        setRedraw(!redraw);
    }

    const ChangeSelectedAll = () => {
        let value = !selectedAll;

        items.forEach(item => {
            item.selected = value;
        });

        setSelectedAll(value);
    }

    const ChangeMaxItems = (item) => {
        setMaxItems(item);
        db_get(0, filter, item);
    }

    const DialogExportResult = (typ, note) => {
        setShowExport(false);

        if (typ == true) {
            var itemRows = []; // zoznam IDs ktore budú exportované (0 -> všetky)

            switch (menuIndex) {
                case 1:
                    items.forEach(item => {
                        if (item.selected == true) {
                            itemRows.push(item.id);
                        }
                    });
                    if (itemRows.length > 0) {
                        db_export(itemRows, note);
                    }
                    break;

                case 2:
                    itemRows = false;
                    db_export(itemRows, note);
                    break;
            }
        }
    }

    const SearchButtonResult = (id) => {
        var tmp = searchColumns.find(x => x.id === id);
        if (tmp != undefined) {
            tmp.checked = !tmp.checked;
        }
        if (search != '') {
            Search(search);
        } else {
            setRedraw(!redraw);
        }
    }

    const ChangeCodebook = (id) => {
        setBookIndex(id);
        Debug(id);

        if (tabIndex == 0) {
            var book_id = global.codebook.reasons;

            if (id == 0) {
                book_id = global.codebook.reasons;
            }
            if (id == 1) {
                book_id = global.codebook.reasons_transport;
            }
            if (id == 2) {
                book_id = global.codebook.reklamacia_reason;
            }
            if (id == 3) {
                book_id = global.codebook.reklamacia_deny;
            }
            if (id == 4) {
                book_id = global.codebook.plans;
            }
            if (id == 5) {
                book_id = global.codebook.product_book_1;
            }
            if (id == 6) {
                book_id = global.codebook.product_book_2;
            }
            if (id == 7) {
                book_id = global.codebook.product_book_3;
            }
            if (id == 8) {
                book_id = global.codebook.blogs;
            }
            if (id == 9) {
                book_id = global.codebook.newsletter_emails;
            }
            if (id == 10) {
                book_id = global.codebook.product_parameters;
            }
            if (id == 100) {
                book_id = global.codebook.user_defined;
            }
        } else {
            book_id = id;
        }
        setCodeBookID(book_id);


        db_get(book_id, filter);
    }

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const onDragEnd = (result) => {
        if (result.destination) {
            const tmp = reorder(items, result.source.index, result.destination.index);

            var n = 1;
            var items_ = [];
            tmp.forEach(item => {
                item.priority = n;

                let data = {
                    id: item.id,
                    priority: n
                }
                items_.push(data);
                n++
            });

            setItems(tmp);
            db_reorder(items_);
        }
    }

    const ChangeTab = (id) => {
        setCodeBookID(-1);
        setBookIndex(-1);
        setItems(false);
        setItemsFiltered(false);
        setTabIndex(id);

        if (id == 0) {
        }
        if (id == 1) {
        }

    }
    return (
        <Paper elevation={global.menu_elevation} style={{ width: props.width, height: props.height, borderRadius: props.radius }}>
            <div style={{ ...styles.BlockRow, height: global.widow_bar_height, borderTopLeftRadius: props.radius, borderTopRightRadius: props.radius, background: color.window_bar_color }}>
                <div style={{ ...styles.Block, width: 60, height: global.widow_bar_height }}>
                    <Icon theme={props.theme} icon={faLayerGroup} />
                </div>
                <div style={{ ...styles.Block, width: props.width - 180, height: global.widow_bar_height, alignItems: 'flex-start' }}>
                    <p style={{ ...styles.TextDialogLabel }}>{props.title}</p>
                </div>
                <div style={{ ...styles.Block, width: 60, height: global.widow_bar_height }}>
                    <MenuButton id={0} menuItems={itemsExportMenu} theme={props.theme} func={MenuResult.bind()} />
                </div>
                <div style={{ ...styles.Block, width: 60, height: global.widow_bar_height }}>
                    <IconButton onClick={() => Close()} style={{ ...styles.ButtonClose }}>
                        <FontAwesomeIcon style={{ width: 10 }} icon={faXmark} />
                    </IconButton>
                </div>
            </div>
            {/* BODY */}
            <div style={{ ...styles.BlockCenter, height: props.height - global.widow_bar_height, backgroundColor: color.back, borderBottomLeftRadius: props.radius, borderBottomRightRadius: props.radius }}>
                <div style={{ ...styles.BlockCenter, height: props.height - global.widow_bar_height }} >
                    <div id={'id_start'} style={{ ...styles.Block, maxWidth: global.max_width, width: '100%' }}>

                        {props.system.eshop_enabled == true ?
                            <div style={{ ...styles.Block, height: tabHeight }}>
                                <DialogTabs center value={tabIndex} items={tabs} width={240} theme={props.theme} func={(id) => ChangeTab(id)} />
                            </div>
                            : null}

                        <div style={{ ...styles.Block, width: '96%', marginTop: 10 }}>
                            <div style={{ ...styles.BlockRow }}>
                                <div style={{ ...styles.BlockLeft, width: 220, height: menuHeight }}>
                                    <div style={{ ...styles.BlockRowRaw }}>
                                        <TextInput search theme={props.theme} width={200} enabled={true} lang={lang} value={search} label={''} placeholder={lang.search} func={(txt) => Search(txt)} />
                                        <div style={{ ...styles.Block, width: 30, paddingTop: 3 }}>
                                            <SearchButton menuItems={searchColumns} lang={lang} theme={props.theme} func={SearchButtonResult.bind()} />
                                        </div>
                                    </div>
                                </div>
                                <div style={{ ...styles.Block, width: '56%', height: menuHeight }}>
                                    {tabIndex == 0 ?
                                        <FormSelect value={bookIndex} items={codebooks.filter(x => x.enabled == true)} field={'label'} editing={true} title={lang.codebook} width={300} column1={100} column2={300} theme={props.theme} lang={lang} radius={props.radius} func={(id) => ChangeCodebook(id)} />
                                        : null}
                                    {tabIndex == 1 ?
                                        <FormSelect value={bookIndex} items={false} field={'name'} codebook={global.codebook.user_defined} codebook_icon={faPlus} title={lang.codebook} editing={true} column1={100} width={250} column2={300} theme={props.theme} lang={lang} radius={props.radius} organization={props.organization} user={props.user} token={props.token} permissions={props.permissions} func={(id) => ChangeCodebook(id)} />
                                        : null}
                                </div>
                                <div style={{ ...styles.BlockRight, width: 220, height: menuHeight }}>
                                    {CheckPermission(props.user.super_admin, props.permissions[permission_column]).write == true ?
                                        <Button onClick={() => AddNew()} style={{ ...styles.ButtonThemed, backgroundColor: color.button_add, width: 180 }}>
                                            <FontAwesomeIcon style={{ height: 16, color: color.white, marginRight: 6 }} icon={faPlusCircle} />
                                            {bookIndex == 100 ? lang.codebook_new : lang.codebook_value_new}
                                        </Button>
                                        : null}
                                </div>
                            </div>

                            <div style={{ ...styles.Block, marginTop: 20 }}>

                                {/* ****************************************************************************************************************
                                        TABLE HEADER
                                **************************************************************************************************************** */}

                                <div style={{ ...styles.Block, width: rowWidth, marginBottom: 10, border: color.border }}>
                                    <div style={{ ...styles.BlockRow, width: '99%' }}>
                                        <div style={{ ...styles.Block, width: 50, height: tableLabelHeight, justifyContent: 'center' }}>
                                            {/* SELECT */}
                                            <div style={{ ...styles.Block, height: tableLabelHeight, justifyContent: 'center' }}>
                                                <Checkbox checked={selectedAll} size={'small'} onChange={() => ChangeSelectedAll()} />
                                            </div>
                                        </div>
                                        <div style={{ ...styles.Block, width: 100 }}>
                                            {/* DATA */}
                                            <div style={{ ...styles.BlockLeft, height: tableLabelHeight, justifyContent: 'center', borderLeft: color.border }}>
                                                <p style={{ ...styles.TextTiny, color: color.dark_gray, marginLeft: 10 }}>{lang.label}</p>
                                            </div>
                                        </div>
                                        <div style={{ ...styles.Block, width: '80%' }}>
                                            {/* DATA */}
                                            <div style={{ ...styles.Block, height: tableLabelHeight, justifyContent: 'center' }}>

                                                {bookIndex == 0 ?
                                                    <p style={{ ...styles.TextXSmall, textAlign: 'center', fontWeight: '600' }}>{lang.codebook_adjust_label}</p>
                                                    : null}
                                                {bookIndex == 1 ?
                                                    <p style={{ ...styles.TextXSmall, textAlign: 'center', fontWeight: '600' }}>{lang.codebook_trans_label}</p>
                                                    : null}
                                                {bookIndex == 2 ?
                                                    <p style={{ ...styles.TextXSmall, textAlign: 'center', fontWeight: '600' }}>{lang.reklamacia_reasons_label}</p>
                                                    : null}
                                                {bookIndex == 3 ?
                                                    <p style={{ ...styles.TextXSmall, textAlign: 'center', fontWeight: '600' }}>{lang.reklamacia_denies_label}</p>
                                                    : null}
                                                {bookIndex == 4 ?
                                                    <p style={{ ...styles.TextXSmall, textAlign: 'center', fontWeight: '600' }}>{lang.plan_types}</p>
                                                    : null}
                                                {bookIndex == 10 ?
                                                    <p style={{ ...styles.TextXSmall, textAlign: 'center', fontWeight: '600' }}>{lang.product_params_label}</p>
                                                    : null}
                                                {bookIndex == 100 ?
                                                    <p style={{ ...styles.TextXSmall, textAlign: 'center', fontWeight: '600' }}>{lang.codebook_user_defined_label}</p>
                                                    : null}
                                            </div>
                                        </div>
                                        <div style={{ ...styles.Block, width: 50 }}></div>
                                        <div style={{ ...styles.BlockRow, width: 100, borderLeft: color.border }}>
                                            {/* ENABLED */}
                                            <div style={{ ...styles.BlockLeft, height: tableLabelHeight, justifyContent: 'center' }}>
                                                <p style={{ ...styles.TextTiny, color: color.dark_gray, marginLeft: 10 }}>{lang.enabled}</p>
                                            </div>
                                            <div style={{ ...styles.Block, width: 30, height: tableLabelHeight, justifyContent: 'center' }}>
                                                <MenuButton id={2} sortMenu={true} menuItems={itemsOrdering} theme={props.theme} func={MenuSortResult.bind()} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ****************************************************************************************************************
                                        DATA
                                **************************************************************************************************************** */}
                                <div style={{ ...styles.BlockCenter, width: rowWidth, height: props.height - global.widow_bar_height - tabHeight - tableLabelHeight - 40 - 60, msOverflowStyle: 'none', scrollbarWidth: 'none', overflowY: 'scroll' }} className='container'>

                                    {
                                        items != false ?
                                            <DragDropContext onDragEnd={onDragEnd}>
                                                <Droppable droppableId="droppable">
                                                    {(provided) => (
                                                        <div
                                                            {...provided.droppableProps}
                                                            ref={provided.innerRef}
                                                            style={{ ...styles.BlockLeft, width: '100%' }}
                                                        >
                                                            {items.map((item, index) => (
                                                                <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                                                                    {(provided, snapshot) => (
                                                                        <div
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                        >
                                                                            <Paper
                                                                                key={item.id}
                                                                                elevation={item.id == overID ? 4 : 1}
                                                                                style={{
                                                                                    ...styles.Block, width: rowWidth,
                                                                                    backgroundColor: item.enabled == false ? color.disabled : color.white,
                                                                                    borderRadius: global.items_radius,
                                                                                    minHeight: rowHeight,
                                                                                    cursor: 'pointer',
                                                                                    marginTop: 5, marginBottom: 5,
                                                                                    paddingTop: 2, paddingBottom: 2,
                                                                                    borderLeft: item.enabled == false ? color.disabled_border : '',
                                                                                }}
                                                                                onMouseOverCapture={() => setOverID(item.id)} onMouseLeave={() => setOverID(-1)}
                                                                            >
                                                                                <div style={{ ...styles.BlockRow, width: '98%' }}>
                                                                                    <div style={{ ...styles.BlockLeft, width: 50, height: rowHeight, justifyContent: 'center' }}>
                                                                                        {/* SELECT */}
                                                                                        <Checkbox checked={item.selected == true ? true : false} size={'small'} onChange={() => ChangeSelected(item)} />
                                                                                    </div>

                                                                                    <div onClick={() => SelectItem(item)} style={{ ...styles.BlockLeft, width: '90%', minHeight: rowHeight }}>
                                                                                        <div style={{ ...styles.BlockRowRaw }}>
                                                                                            {tabIndex == 1 && item.color != '' ?
                                                                                                <div style={{ ...styles.BlockLeft, minHeight: rowHeight, width: undefined, marginRight: 10 }}>
                                                                                                    <div style={{ ...styles.Block, width: rowHeight - 10, height: rowHeight - 10, borderRadius: (rowHeight - 10) / 2, backgroundColor: item.color }}></div>
                                                                                                </div>
                                                                                                : null}
                                                                                            <div style={{ ...styles.BlockLeft, minHeight: rowHeight, width: undefined }}>
                                                                                                <p style={{ ...styles.TextXSmall, color: color.dark_gray }}>{item.name}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div style={{ ...styles.Block, width: 100, minHeight: rowHeight, justifyContent: 'center' }}>
                                                                                        {/* ENABLED */}
                                                                                        {CheckPermission(props.user.super_admin, props.permissions[permission_column]).edit == true ?
                                                                                            <SwitchEnable enabled={item.enabled == false ? false : true} theme={props.theme} func={(value) => ChangeEnabled(item, value)} />
                                                                                            : null}
                                                                                        {item.enabled == false ?
                                                                                            <div style={{ ...styles.Block, height: 20 }}>
                                                                                                <p style={{ ...styles.TextXXTiny, color: color.dark_gray }}>{lang.disabled}</p>
                                                                                            </div>
                                                                                            : null}
                                                                                    </div>
                                                                                </div>
                                                                            </Paper>
                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            ))}
                                                            {provided.placeholder}
                                                        </div>
                                                    )}
                                                </Droppable>
                                            </DragDropContext >
                                            : null
                                    }

                                    {/* ****************************************************************************************************************
                                        PAGINATION
                                    **************************************************************************************************************** */}

                                    <div style={{ ...styles.BlockRow, height: 80, paddingBottom: global.empty_padding, borderTop: '1px solid ' + global.theme_light_gray }}>
                                        <div style={{ ...styles.Block, width: 200 }}></div>
                                        <div style={{ ...styles.Block, height: 80, width: '90%', height: paginationHeight }}>
                                            {pages > 1 ?
                                                <Pagination count={pages} size={'medium'} page={parseInt(page) + 1} onChange={(event, value) => ChangePage(value)} showFirstButton showLastButton />
                                                : null}
                                        </div>
                                        <div style={{ ...styles.Block, height: 80, width: 200 }}>
                                            <div style={{ ...styles.BlockRowRaw }}>
                                                <div style={{ ...styles.BlockRight, width: 100, height: 36, height: paginationHeight }}>
                                                    <p style={{ ...styles.TextXXTiny, textAlign: 'right', lineHeight: 1 }}>{lang.items_count}</p>
                                                </div>
                                                <div style={{ ...styles.Block, width: 90, marginLeft: 10, height: paginationHeight }}>
                                                    <SelectInput theme={props.theme} enabled={true} lang={lang} value={maxItems} items={global.max_items_on_page} field={'label'} label={lang.mobil} radius={global.radius} func={(item) => ChangeMaxItems(item)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {showExport == true ?
                <DialogExport remote={props.remote} remoteMobile={props.remoteMobile} rows={3} title={lang.export_note} text={''} icon={faQuestion} button={props.lang.export} theme={props.theme} radius={props.radius} lang={lang} func={DialogExportResult.bind(this)} />
                : null}

            {showDialog == true ?
                <CodeBook items={items} createbook={codeBookID == global.codebook.user_defined ? true : undefined} color={tabIndex == 1 ? true : undefined} params={codeBookID == global.codebook.product_parameters ? true : undefined} itemsCount={items == false ? 0 : items.length} remote={props.remote} remoteMobile={props.remoteMobile} module_id={module_id} codebook={codeBookID} item={itemSelected} organization={props.organization} locale={props.locale} user={props.user} lang={props.lang} language={props.language} permissions={props.permissions} permission_column={permission_column} theme={props.theme} offset={props.offset} radius={props.radius} precision={props.precision} isSmall={props.isSmall} title={lang.cond_designer} token={props.token} func={DialogResult.bind()} />
                : null}

            {showOK == true ?
                <ShowOK theme={props.theme} func={() => setShowOK(false)} />
                : null}

            {showError == true ?
                <ShowError theme={props.theme} text={lang.db_error} sub_text={lang.db_error_text} func={() => setShowError(false)} />
                : null}

            {isBusy == true ?
                <Loading offset={props.offset}></Loading>
                : null}

        </Paper >
    );
}



/*
*
* =================================================================================================================
* UPRAVA / NOVY ZÁZNAM
* =================================================================================================================
*
*/
export const CodeBook = (props) => {

    let module_id = props.module_id;
    let permission_column = props.permission_column;

    var lang = props.lang;
    let radius = props.radius;
    let color = global.themes[props.theme];
    let permissions = global.permissions;

    // IMAGES
    const no_image = require('./react/app/no_image.jpg');

    // SYSTEM
    const [isBusy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [editing, setEditing] = useState(props.item == false ? true : false);

    const [showOK, setShowOK] = useState(false);
    const [showError, setShowError] = useState(false);

    // DATA
    const [enabled, setEnabled] = useState(true);
    const [name, setName] = useState('');
    const [paramID, setParamID] = useState(0);
    const [codebookID, setCodebookID] = useState(0);
    const [userColor, setUserColor] = useState('#00000000');

    let params = [
        { id: 0, name: lang.parameter_types[0] },
        { id: 1, name: lang.parameter_types[1] },
        { id: 2, name: lang.parameter_types[2] },
        { id: 3, name: lang.parameter_types[3] },

    ];

    // SCREEN SETTINGS
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    const dialogWidth = width >= 680 ? 680 : width;
    const dialogHeight = props.params == true ? height >= 350 ? 350 : height : props.color == true ? 320 : 300;

    // CONSTANTS
    const tabHeight = props.item == false ? 0 : 40;
    const buttonHeight = 70;
    const errorHeight = 40;
    const column1 = 200;
    const column2 = dialogWidth - column1 - 40;

    let { func } = props;
    var running = false;

    useEffect(() => {
        if (running == false) {

            if (props.item != false) {
                // EDITACIA POLOZKY -> UDAJE Z DB
                AssignData(props.item);
            }

            running = true;
        }

    }, []);

    const db_update = async (data) => {
        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'codebook_update', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: props.token,
                    user_id: props.user.id,
                    organization_id: props.organization.id,
                    // -------------------------------------
                    data: data
                })
            })

            const json = await response.json();

            if (json.ok > 0) {
                setShowOK(true);
            } else {
                setShowError(true);
            }
            setBusy(false);

        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }

    const Close = () => {
        func(false);
    }

    const AssignData = (item) => {
        // priradenie údajov pri načítaní z DB
        setEnabled(item.enabled == false ? false : true);
        setName(item.name);
        setParamID(item.parameter);
        setCodebookID(item.codebook_id);
        setUserColor(item.color == '' ? '#00000000' : item.color);
    }

    const Save = () => {
        setError('');


        var error = false;
        var err_text = lang.required_red;
        var name_ = name.trim();

        error += IsEmpty(name_) == true ? 1 : 0;
        if (paramID == 3) {
            error += codebookID == 0 ? 1 : 0;
        }

        if (props.items != false) {
            var tmp = props.items.find(x => parseInt(x.id) != props.item.id && x.name.trim().toLowerCase() == name_.toLowerCase());
            if (tmp != undefined) {
                error++;
                err_text = lang.codebook_item_exists;
            }
        }

        if (error == 0) {
            let data = {
                id: props.item == false ? 0 : props.item.id,
                organization_id: props.organization.id,
                enabled: enabled,
                book_id: props.codebook,
                name: name,
                parameter: paramID,
                codebook_id: codebookID,
                color: userColor == '#00000000' ? '' : userColor,
                priority: 100
            };

            db_update(data);

        } else {
            setError(err_text);
        }

    }

    const ShowOKPress = () => {
        func(true);
    }


    return (
        <Backdrop open={true} style={{ paddingLeft: props.center == true ? 0 : GetLeftPosition(width), backgroundColor: props.backcolor == false ? '#00000000' : '#000000AA', zIndex: 2000, top: props.remote == true && props.remoteMobile == true ? -400 : 0 }}>
            <Paper elevation={global.menu_elevation} style={{ width: dialogWidth, height: dialogHeight, borderRadius: props.radius }}>
                <div style={{ ...styles.BlockRow, height: global.dialog_bar_height, borderTopLeftRadius: props.radius, borderTopRightRadius: props.radius, background: color.window_bar_color }}>
                    <div style={{ ...styles.Block, width: 60, height: global.dialog_bar_height }}>
                        <Icon theme={props.theme} icon={faLayerGroup} logo />
                    </div>
                    <div style={{ ...styles.Block, width: dialogWidth - 120, height: global.dialog_bar_height, alignItems: 'flex-start' }}>
                        <p style={{ ...styles.TextDialogLabel }}>{props.item == false ? props.createbook == true ? lang.codebook_new : lang.codebook_value_new : props.createbook == true ? lang.codebook_edit : lang.codebook_value_edit}</p>
                    </div>
                    <div style={{ ...styles.Block, width: 60, height: global.dialog_bar_height }}>
                        <IconButton onClick={() => Close()} style={{ ...styles.ButtonClose }}>
                            <FontAwesomeIcon style={{ width: 10 }} icon={faXmark} />
                        </IconButton>
                    </div>
                </div>
                {/* BODY */}
                <div style={{ ...styles.BlockCenter, height: dialogHeight - global.dialog_bar_height, backgroundColor: color.back, borderBottomLeftRadius: props.radius, borderBottomRightRadius: props.radius }}>

                    <div style={{ ...styles.BlockCenter, height: dialogHeight - global.dialog_bar_height - buttonHeight - errorHeight, msOverflowStyle: 'none', scrollbarWidth: 'none', overflowY: 'scroll' }} className='container'>
                        <div>
                            <FormSpace />
                            <FormYesNo value={enabled} editing={true} title={lang.order_type_enabled} column1={column1} column2={column2} theme={props.theme} lang={lang} radius={props.radius} func={(value) => setEnabled(value)} />
                            <FormText require redraw value={name} editing={true} title={lang.codebook_name} column1={column1} column2={column2} theme={props.theme} lang={lang} radius={props.radius} func={(txt) => setName(txt)} />
                            {props.params == true ?
                                <>
                                    <FormSelect value={paramID} items={params} field={'name'} editing={true} title={lang.parameter_typ} width={'100%'} column1={column1} column2={column2} theme={props.theme} lang={lang} radius={props.radius} func={(id) => setParamID(id)} />
                                    {paramID == 3 ?
                                        <FormSelect require value={codebookID == 0 ? -1 : codebookID} items={false} field={'name'} codebook={global.codebook.user_defined} editing={true} title={lang.codebook} width={'100%'} column1={column1} column2={column2} theme={props.theme} lang={lang} radius={props.radius} organization={props.organization} user={props.user} token={props.token} permissions={props.permissions} func={(id) => setCodebookID(id)} />
                                        : null}
                                </>
                                : null}
                            {props.color == true ?
                                <>
                                    <FormColors palette value={userColor} editing={true} title={lang.codebook_color} column1={column1} column2={column2} theme={props.theme} lang={lang} radius={props.radius} organization={props.organization} user={props.user} token={props.token} func={(id) => setUserColor(id)} />
                                </>
                                : null}
                            <FormSpace />

                        </div>
                    </div>

                    <div style={{ ...styles.Block, height: errorHeight }}>
                        <FormError small margin={0} error={error} theme={props.theme} />
                    </div>
                    <div style={{ ...styles.Block, height: buttonHeight }}>
                        <div style={{ ...styles.BlockRowRaw }}>
                            <Button onClick={() => Save()} style={{ ...styles.ButtonThemed, backgroundColor: color.button_ok, marginRight: 20 }}>{lang.save}</Button>
                            <Button onClick={() => Close()} style={{ ...styles.ButtonThemed, backgroundColor: color.button_cancel }}>{lang.close}</Button>
                        </div>
                    </div>
                </div >


                {showOK == true ?
                    <ShowOK theme={props.theme} func={ShowOKPress.bind(this)} />
                    : null}

                {showError == true ?
                    <ShowError theme={props.theme} text={lang.db_error} sub_text={lang.db_error_text} func={() => setShowError(false)} />
                    : null}

                {isBusy == true ?
                    <Loading offset={props.offset}></Loading>
                    : null}

            </Paper >
        </Backdrop>
    );
}

